import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const withdrawlHistoryThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.getWithdrawlHistory, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getUserWithdrawlMiscellanousThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getUserWithdrawlMiscellanousData)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getAdminSettingsThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getAdminSettings)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const verifyBankDetailsThunk = async () => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.verifyBankDetails)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const createWithdrawRequestThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.createWithdrawRequest, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const withdrawalPayoutInvoiceDownloadThunk = async (withdrawal_id) => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.withdrawalPayoutInvoiceDownload(withdrawal_id))
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getAccVerificationDataThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getVerifiedBankDetailsOfUser, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}
